import { API_URL } from "config";
import Http from "util/https";
import { PrefStockList, PrefStockParams, PrefStockResponseApi, SupplierResponseApi, SupplierSearchApiParams, SupplierStockList } from "../types/index";
import { convertUTCToDate, nullToZero } from "../utils/common";
import { supplierStockApiResponse } from "./apiConstants";


/**
 * 都道府県毎の本部用在庫更新Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns SupplierStockList
 */
export default async function getPrefStockListApi(params: PrefStockParams): Promise<PrefStockList> {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/stock/vendor/depot/stocks`;
  const res = await http.post<PrefStockResponseApi>(url, params);
  // const res: {data: PrefStockResponseApi} = {
  //   data: {
  //     stock_list: Array.from({length: 47}, (_, i) => String(999994 + i + 1)),
  //   }
  // }
  // await new Promise((resolve) => {setTimeout(resolve, 1500)});
  console.log("getPrefStockListApi res:", res);

  const stockList = res.data.slice().sort((a, b) => Number(a.pref_cd) - Number(b.pref_cd))
  // 一意にする
  const seen = new Set<string>();
  const uniqueSorted = stockList.filter(s => {
    if (seen.has(s.pref_cd)) {
      return false;
    }
    seen.add(s.pref_cd);
    return true;
  }).map(s => `${s.quantity}`);
  console.log("getPrefStockListApi uniqueSorted:", uniqueSorted);
  return uniqueSorted;
}